<template>
	<div class="list-container column">
		<div class="title">{{ $t('rolelist.title') }}</div>
		<div class="panel-list-header">
			<div class="panel-header-item">{{ $t('rolelist.name') }}</div>
			<div class="panel-filler" v-if="$isAllowedTo('roles_edit')" />
			<div class="panel-filler" v-if="$isAllowedTo('roles_edit')" />
		</div>
		<div
			class="panel-list"
			v-for="role in roles"
			:key="role.id"
			@click.stop="onEdit(role)"
		>
			<p class="panel-list-item">{{ role.name }}</p>
			<div class="list-button" v-if="$isAllowedTo('roles_edit')" @click.stop="onEdit(role)">
				<i class="fas fa-edit"></i>
			</div>
			<div class="list-button" v-if="$isAllowedTo('roles_edit')" @click.stop="onDelete(role)">
				<i class="fas fa-trash-alt"></i>
			</div>
		</div>
		<div class="panel-list no-hover" v-if="roles.length == 0">
			<p class="panel-list-item">{{ $t('rolelist.no_results') }}</p>
		</div>
		<Pagination
			v-if="roles.length > 0"
			:pagination="pagination"
			@paginate="paginate"
			@updatePageSize="updatePageSize"
		/>
	</div>
</template>

<script>
import Pagination from '@/components/Pagination';
import { mapGetters, mapActions } from 'vuex';

export default {
	components: {
		Pagination
	},

	props: {
		roles: Array
	},

	computed: {
		...mapGetters('roleStore', ['pagination']),
		...mapGetters('appStore', ['isMobile'])
	},

	methods: {
		...mapActions('roleStore', ['setCurrentPage', 'setPageSize']),

		onDelete(role) {
			this.$emit('delete', role);
		},

		onEdit(role) {
			if (this.$isAllowedTo('roles_edit')) this.$emit('edit', role);
		},

		paginate(page) {
			this.setCurrentPage(page);
			this.$emit('search');
		},

		updatePageSize(size) {
			this.setPageSize(size);
			this.setCurrentPage(1);
			this.$emit('search');
		}
	}
};
</script>
